/**
 * Email validation policy — Zod-free primitive constants.
 *
 * Shared between `@artemis/validators`' `emailSchema` (Zod) and the
 * identity domain `Email` value object. The domain layer imports these
 * constants through the package barrel (AUDIT-107 boundary discipline:
 * domain may depend on `@artemis/validators` primitives but not on
 * Zod at runtime).
 *
 * `EMAIL_PATTERN` is ported verbatim from Zod v3.25.76 `.email()`
 * (types.js line 384). The `i` flag folds the `[A-Z]` character
 * classes over lowercase input; explicit boundary checks
 * (`(?!\.)` / `(?!.*\.\.)`) reject leading and consecutive dots in
 * the local part.
 *
 * `EMAIL_ERROR_MESSAGE` is Zod v3's default wording for `.email()`.
 * Concatenated into the domain VO throw as
 *   `Invalid email "${input}": ${EMAIL_ERROR_MESSAGE}`
 * which preserves the `Invalid email "<input>": Invalid email`
 * surface that callers and serialised payloads depend on.
 */
export const EMAIL_PATTERN = /^(?!\.)(?!.*\.\.)[A-Z0-9_'+.-]*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;
export const EMAIL_ERROR_MESSAGE = 'Invalid email';
//# sourceMappingURL=email.js.map